export default "<app-dashboard></app-dashboard>";